<template>
  <div class="date-picker">
    <DatePicker righttoleft="true" :initRange="initRange" @closed="onClosed" @selected="onDateSelected" />
  </div>
</template>

<script>
import DatePicker from "./DatePicker";
export default {
  components: {
    DatePicker,
  },
  props: {
    selectedDate: {
      type: Object,
      required: true,
    },
  },
  computed: {
    initRange() {
      return {
        start: this.selectedDate.startDate,
        end: this.selectedDate.endDate,
      };
    },
  },
  methods: {
    onDateSelected(daterange) {
      this.$emit("changedDate", daterange);
    },
    onClosed() {},
  },
};
</script>

<style scoped>
.date-picker {
  width: 100%;
}
</style>
